module.exports = __webpack_public_path__ + "static/media/Otros articulos.b4f7b0d7.svg";